/** @format */

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../../constants";
import ServiceList from "../../components/profile/servicelist";
import { toast } from "react-toastify";
// import axios from "axios";
import BrandLogo from "../../components/atoms/brandLogo";
import UnsetProfile from "../unsetProfile";
import Loader from "../../components/atoms/Loader";
import { SubHeading, Left, ImageContainer } from "./styles";
import axios from "axios";
import profileIcon from "../../assets/images/profile.svg";

const Profile = () => {
  let slug = useParams().slug;
  let [profile, setProfile] = useState<any>();
  let [setHero] = useState<any>();
  let [isProfile, setIsProfile] = useState<any>();
  let [isLoading, setIsLoading] = useState(false);

  // save as suggest
  const suggest = () => {
    // Get the URL query string
    const queryString = window.location.pathname;
    // split / from the string
    const parts = queryString.split("/");
    // save to local storage
    localStorage.setItem("suggest", parts[1]);
  };

  const getProfile = async () => {
    setIsLoading(true);
    const profile: any = await fetch(`${API_URL}/profile/slug/${slug}`).catch((error) => {
      toast.error(error);
      setIsLoading(false);
    });
    if (profile) {
      let result = await profile.json();
      setIsLoading(false);
      setIsProfile(true);
      if (result.error) {
        setIsProfile(false);
      }
      getHeader(result?.data?.businessUuid);
      setProfile(result.data);
      getRecordView(result?.data?.businessUuid);
    }
  };

  const getRecordView = async (id: string) => {
    await fetch(`${API_URL}/profile/record-profile-view/${id}`).catch((error) => {
      toast.error(error);
    });
  };

  const getHeader = async (id: string) => {
    axios
      .get(`${API_URL}/heroandheader/${id}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setHero({});
        }
      })
      .catch((error) => {
        if (error?.response?.status === 400 || error?.response?.status === 401) {
          return;
        }
      });
  };

  useEffect(
    () => {
      setIsLoading(true);
      getProfile();
      suggest();
    },
    // eslint-disable-next-line
    []
  );

  const goToTelephone = () => {
    window.location.href = `tel://${profile.phoneNumber}`;
  };

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="loader ">
            <Loader size={1.5} />
          </div>
        </div>
      ) : !isProfile ? (
        <UnsetProfile />
      ) : (
        <>
          <SubHeading className="pt-[6.87em] md:pt-[8.5em]">
            <Left>
              <ImageContainer className="bg-white" >
                <BrandLogo src={profile?.image ? profile?.image : profileIcon} />
              </ImageContainer>
            </Left>
          </SubHeading>
              <>
            <ServiceList goToTelephone={goToTelephone} profile={profile} />
          </>
        </>
      )}
    </>
  );
};

export default Profile;
